import React, { useState, useEffect } from "react";
import { Button, Label, TextInput } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import "../style/Login.css";
import axios from "axios";
import { Link } from "react-router-dom";

const Login = () => {
  const navigate = useNavigate();
  const [Input, setInput] = useState({ username: "", password: "" });
  const [loginData, setLoginData] = useState([]);
  const baseURL = process.env.REACT_APP_BASE_URL;

  const onChangeValue = (e) => {
    setInput({ ...Input, [e.target.name]: e.target.value });
  };

  const loginSubmit = async (e) => {
    e.preventDefault();

    try {
      sessionStorage.clear();
      const response = await axios.post(`${baseURL}/login`, {
        username: Input.username,
        password: Input.password,
      });

      if (
        response.status === 200 &&
        response.data.message === "Login successful"

      ) {
        const { access_token, refresh_token, role, status, message } =
          response.data;
        sessionStorage.setItem("access_token", access_token);
        sessionStorage.setItem("role", role);
        sessionStorage.setItem("status", status);
        console.log(sessionStorage.getItem("access_token"));
        Swal.fire({
          icon: "success",
          text: "Login successful!",
          timer: 2000,
          showConfirmButton: false,
        });
        navigate("/Dashboard");
      } else {
        Swal.fire({
          icon: "error",
          text: "Wrong password or username",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Login error:", error);
      Swal.fire({
        icon: "error",
        text: "An error occurred. Please try again later.",
        timer: 2000,
        showConfirmButton: false,
      });
    }
  };

  return (
    <div className="login-container">
      <div className="contact-box">
        <div className="p-6 login-card bg-white">
          <form className="flex flex-col gap-4" onSubmit={loginSubmit}>
            <div>
              <Label htmlFor="email1" value="Username" />
              <TextInput
                name="username"
                id="username"
                type="text"
                required
                onChange={(e) => onChangeValue(e)}
              />
            </div>
            <div>
              <Label htmlFor="password1" value="Password" />
              <TextInput
                name="password"
                id="password"
                type="password"
                required
                onChange={(e) => onChangeValue(e)}
              />
            </div>
            <div className="text-center text-sm text-blue-600 underline">
  <Link to="/agent-login">Login as Collection Agent</Link>
</div>

            <div className="flex justify-center gap-4">
              <Button type="submit" color="warning">
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
